


































































































































































































































































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import AuthModule from '@/store/modules/Auth';
import GeneralModule from '@/store/modules/General';
import Table from '@/components/Table/Index.vue';
import Breadcrumb from '@/components/Breadcrumb.vue';
import Pagination from '@/components/Pagination.vue';
import DownlineBody from '@/components/Table/DownlineBody.vue';
import DownlineHistoryBody from '@/components/Table/DownlineHistoryBody.vue';
import ManageMixin from '@/mixins/Manage.vue';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';
import UserData from '@/data/User';
import CurrencyModule from '@/store/modules/Currency';
import jwt_decode from 'jwt-decode';

@Component({
  components: {
    Table,
    Breadcrumb,
    Pagination,
    DownlineBody,
    DownlineHistoryBody,
  },
  mixins: [ManageMixin],
})
export default class Downline extends Mixins(ManageMixin, ErrorHandleMixin) {
  AuthInstance = getModule(AuthModule, this.$store);

  GeneralInstance = getModule(GeneralModule, this.$store);

  CurrencyModule = getModule(CurrencyModule, this.$store);

  historyPage = 1;

  userId = this.AuthInstance.user._id;

  username = this.AuthInstance.user.username;

  source = this.AuthInstance.user.source;

  typeagent = this.AuthInstance.user.type;

  searchUsername = '';

  role = 'All';

  startCount = 1;

  PaginationDetail = {
    page: 1,
    amount: 0,
    limit: 100,
  }

  BreadcrumbDefault = [
    {
      username: this.AuthInstance.user.username,
      userId: this.AuthInstance.user._id,
      source: this.AuthInstance.user.source,
      typeagent: this.AuthInstance.user.type,
    },
  ];

  BreadcrumbList: any = [];

  FillterTableHeadDownLine: any = [...UserData.TableHeadDownLine];

  TableHeadTran = UserData.TableHeadTran;

  historyData = [];

  totalCurrency: any = [];

  showFilterCurrency = false;

  currencyRate = {};

  reportCurrency = '';

  async created() {
    await this.fetchUsers();
  }

  submit() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  async fetchUsers() {
    const {
      PaginationDetail: {
        page,
        limit,
      },
      searchUsername,
      BreadcrumbDefault,
      role,
      username,
      source,
      typeagent,
    } = this;
    let res;
    this.GeneralInstance.toggleLoading(true);
    const Response = await this.CurrencyModule.fetchCurrencyRate();
    const allCurrecy = Response.currency;
    this.currencyRate = Response.rateCurrency;
    if (searchUsername) {
      this.role = 'All';
      res = await this.AccountInstance.FetchDownLineSearch({
        username: searchUsername.trim(),
      });
    } else {
      res = await this.AccountInstance.FetchDownLine({
        pageOption: {
          page,
          limit,
        },
        role,
        username,
        source,
        typeagent,
      });
    }
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      const { users, pagination, breadcrumb } = this.AccountInstance.users;
      this.startCount = pagination ? pagination.startCount : 1;
      const resultData = users ? [...users] : [];
      const query = {};
      allCurrecy.forEach(async (v: any) => {
        resultData.forEach(async (w: any) => {
          if (v === w.currency) {
            if (query[v]) query[v] = [...query[v], w.currency].sort();
            else query[v] = [w];
          }
          if (v !== w.currency && !query[v]) query[v] = [];
        });
      });
      const dataCurrency = resultData.map((item: any) => (item.currency ? item.currency : 'THB'));
      this.totalCurrency = [...new Set(dataCurrency.length ? dataCurrency : ['THB'])];
      if (this.AuthInstance.user.role === 'AGENT' || this.AuthInstance.user.role === 'SUBAGENT') {
        const expToken: any = jwt_decode(this.AuthInstance.token);
        this.totalCurrency = [`${String(expToken.currency)}`];
      }
      this.userList = resultData;
      this.PaginationDetail.amount = pagination
        ? pagination.pageAmount
        : 0;
      this.BreadcrumbList = [...BreadcrumbDefault, ...breadcrumb];
    }
    if (['SUPERADMIN', 'COMPANY', 'SUBCOMPANY', 'AGENT'].includes(this.AuthInstance.user.role)) {
      this.FillterTableHeadDownLine[0] = [...UserData.TableHeadDownLine[0]]
        .filter((item: any) => !item.isCompanyHidden);
    }
  }

  changePage(i) {
    this.PaginationDetail.page = i;
    this.fetchUsers();
  }

  async report(user) {
    this.reportCurrency = user.currency;
    this.historyPage = 1;
    this.currentSelectUser = user._id;
    this.GeneralInstance.toggleLoading(true);
    const res = await this.AccountInstance.FetchHistory({ userId: this.currentSelectUser });
    this.GeneralInstance.toggleLoading(false);
    if (res.code) {
      this.checkError(res);
    } else {
      this.pageRenderHistory();
      this.modal.report = true;
    }
  }

  pageRenderHistory() {
    this.historyData = this.AccountInstance.history
      .slice((this.historyPage - 1) * 5, (this.historyPage * 5));
  }

  handlePage(param) {
    this.historyPage += param;
    this.pageRenderHistory();
  }

  editPT(user) {
    this.currentSelectUser = user._id;
    this.modal.pt = true;
  }

  async submitEditPT() {
    const params = {
      userId: this.currentSelectUser,
      general: this.modalData.pt.general / 100,
      pg: this.modalData.pt.general / 100,
      ds: this.modalData.pt.general / 100,
    };
    const res = await this.AccountInstance.UpdateCommission(params);
    this.alert(res);
  }

  alert(res) {
    const { code } = res;
    if (code === 0) {
      this.modalData = {
        profile: UserData.initialUserInfo(),
        lock: UserData.initialLock(),
        password: UserData.initialPassword(),
        pt: UserData.initialPT(),
        refill: UserData.initialRefill(),
        deduct: UserData.initialDeduct(),
      };
    }
    this.modal = UserData.initialModal();
    this.checkError(res);
    this.fetchUsers();
  }

  async handleSub(user) {
    this.prepareFetch(user);
  }

  async handleBreadcrumb(user) {
    this.prepareFetch(user);
  }

  handleLevel() {
    this.PaginationDetail.page = 1;
    this.fetchUsers();
  }

  prepareFetch(user) {
    this.userId = user._id;
    this.username = user.username;
    this.source = user.source;
    this.typeagent = user.type;
    this.PaginationDetail.page = 1;
    this.searchUsername = '';
    this.fetchUsers();
  }
}
